module.exports = __webpack_public_path__ + "img/details_cases.8cd41ccb.png";